export const separateCompany = (company: string) => {
    const persianRegex = /[\u0600-\u06FF]+/g;
    const englishRegex = /[a-zA-Z]+/g;

    const persianWords = company.match(persianRegex) || [];
    const englishWords = company.match(englishRegex) || [];

    return {
        persian: persianWords.join(" "),
        english: englishWords.join(" "),
    };
};
